module.exports = __webpack_public_path__ + "static/fun-time/games/page001_game1/audio//s2_4.mp3";